<template>
    <div class="commonFormStyles materialPlanInfo">
        <HeaderNav
            header-title="订单申请"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <section class="form-con showFontBtn">
            <van-collapse v-model="activeNames">
                <van-collapse-item name="1">
                    <div slot="title">
                        <span class="iconfont icondanjubianhao"></span>
                        <span class="tit-text">基本信息</span>
                    </div>
                    <div class="form-group">
                        <van-cell-group>
                            <van-cell
                                title="订单编号"
                                :value="formData.order_number"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-cell
                                title="登记时间"
                                :value="formData.bill_time"
                                :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            ></van-cell>
                            <van-cell
                                title="合同编号"
                                :value="formData.contract_number"
                                :icon="require('@/assets/images/icons/icon_2.png')"
                            ></van-cell>
                            <van-cell
                                title="合同类型"
                                :value="formData.contract_type"
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            ></van-cell>
                            <van-cell
                                title="工程名称"
                                :value="formData.project_name"
                                :icon="require('@/assets/images/icons/icon_2.png')"
                            ></van-cell>
                            <van-cell
                                title="工程类型"
                                :value="formData.project_type_name"
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            ></van-cell>
                            <van-cell
                                title="工程地址"
                                :value="formData.project_address"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="当前收货地址"
                                :value="formData.project_address1"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="相关单体"
                                :value="formData.monomer_name"
                                :icon="require('@/assets/images/icons/icon_gy_8.png')"
                            ></van-cell>
                            <van-cell
                                title="施工楼层"
                                v-if="$store.state.versionMark == 2"
                                :value="formData.cons_floor"
                                :icon="require('@/assets/images/icons/icon_gy_8.png')"
                            ></van-cell>
                            <van-cell
                                title="客户名称"
                                :value="formData.customer_name"
                                :icon="require('@/assets/images/icons/icon_3.png')"
                            ></van-cell>
                            <van-cell
                                title="统一信用代码(身份证)"
                                :value="formData.customer_xydm"
                                :icon="require('@/assets/images/icons/icon_33.png')"
                            ></van-cell>
                            <van-cell
                                title="要料人"
                                :value="formData.gdylr"
                                :icon="require('@/assets/images/icons/icon_3.png')"
                            ></van-cell>
                            <van-cell
                                title="联系电话"
                                :value="formData.gdylr_phone"
                                :icon="require('@/assets/images/icons/icon_4.png')"
                            ></van-cell>
                            <van-cell
                                title="供应站点"
                                :value="formData.station_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="运距"
                                :value="formData.haul_distance"
                                :icon="require('@/assets/images/icons/icon_gy_10.png')"
                            ></van-cell>
                            <van-cell
                                title="订单方量"
                                :value="formData.quantity"
                                :icon="require('@/assets/images/icons/icon_30.png')"
                            ></van-cell>
                            <van-cell
                                title="现场联系人"
                                :value="formData.xclxr"
                                :icon="require('@/assets/images/icons/icon_3.png')"
                            ></van-cell>
                            <van-cell
                                title="联系电话"
                                :value="formData.xclxr_phone"
                                :icon="require('@/assets/images/icons/icon_4.png')"
                            ></van-cell>
                            <van-cell
                                title="到货时间"
                                :value="formData.arrival_time"
                                :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            ></van-cell>
                        </van-cell-group>
                    </div>
                </van-collapse-item>
                <van-collapse-item name="2">
                    <div slot="title">
                        <span class="iconfont icondanjubianhao"></span>
                        <span class="tit-text">其他信息</span>
                    </div>
                    <div class="form-group">
                        <van-cell-group>
                            <van-cell
                                title="强度等级"
                                :value="formData.strength_grade_name"
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            ></van-cell>
                            <van-cell
                                title="附加型号"
                                :value="formData.special_require_name"
                                :icon="require('@/assets/images/icons/icon_6.png')"
                            ></van-cell>
                            <van-cell
                                title="工程结构"
                                v-if="$store.state.versionMark == 2"
                                :value="formData.place_category_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="施工部位"
                                v-if="$store.state.versionMark == 2"
                                :value="formData.place_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="施工部位描述"
                                v-if="$store.state.versionMark == 2"
                                :value="formData.place_detail"
                                :icon="require('@/assets/images/icons/icon_gy_4.png')"
                            ></van-cell>
                            <van-cell
                                title="运输方式"
                                :value="formData.transport_name"
                                :icon="require('@/assets/images/icons/icon_11.png')"
                            ></van-cell>
                            <van-cell
                                title="浇筑方式"
                                :value="formData.pouring_name"
                                :icon="require('@/assets/images/icons/icon_32.png')"
                            ></van-cell>
                            <van-cell
                                title="泵车类型"
                                :value="formData.pump_truck_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="工地限高(米)"
                                :value="formData.limited_height"
                                :icon="require('@/assets/images/icons/icon_32.png')"
                            ></van-cell>
                            <van-cell
                                title="工地限方"
                                :value="formData.limited_volume"
                                :icon="require('@/assets/images/icons/icon_32.png')"
                            ></van-cell>
                            <van-cell
                                title="坍落度"
                                :value="`${formData.slump}±${formData.slump_name}`"
                                :icon="require('@/assets/images/icons/icon_32.png')"
                            ></van-cell>
                        </van-cell-group>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <div class="option-con">
                <p>工程描述</p>
                <span class="iconfont iconbeizhu"></span>
                <textarea readonly v-model="formData.project_detail" placeholder="工程描述">
                </textarea>
            </div>
            <div class="option-con">
                <p>备注</p>
                <span class="iconfont iconbeizhu"></span>
                <textarea readonly v-model="formData.remarks" placeholder="备注信息">
                </textarea>
            </div>
        </section>
        <footer class="commonFormBtns">
            <van-button type="info" @click="toMsg">
                沟通
            </van-button>
        </footer>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            activeNames: ['1', '2'],
            formData: {}, // 表单数据
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 通过订单编号获取
        getProductorder(orderNum) {
            this.$axios
                .get('/interfaceApi/production/productorder/number/' + orderNum)
                .then(res => {
                    if (res) {
                        if (!res.slump) {
                            res.slump = '';
                        }
                        if (!res.slump_name) {
                            res.slump_name = '';
                        }
                        this.formData = res;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 拉取合同关联用户（云信群组）
        getContractUserPhone() {
            return this.$axios.get('/interfaceApi/sale/contract_manager/get_contract_user_phone/' + this.currentContractNumber);
        },
        // 拉取用户云信Id列表
        getAccids(phones) {
            return this.$axios.post('/interfaceApi/message/MessageNetease/get_accids', phones);
        },
        // 发起聊天 
        async toMsg() {
            this.currentContractNumber = this.$route.params.contract_number;
            const res = await this.getContractUserPhone();
            if (res) {
                if (res.netease_group_id === null || res.netease_group_id === '') {
                    const accids = await this.getAccids(res.phones);
                    if (accids) {
                        const callMobileData = {
                            uids: accids,
                            groupName: res.group_name,
                            type: '0',
                            contractId: this.$route.params.contract_number,
                        };
                        this.$callMobile('JYTeamsNative', 'jyCreatedGroupWithContractInfo', callMobileData);
                    } else {
                        this.$toast('当前订单暂时无法进行沟通！');
                    }
                } else {
                    const callMobileData = {
                        conversationId: res.netease_group_id,
                        name: res.group_name,
                        type: '1',
                    };
                    this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
                }
            } else {
                this.$toast('当前订单暂时无法进行沟通！');
            }
        },
        // 原生调js回传群组json
        callback_GetTeamsListInfo(chartGroupJson) {
            const groupData = JSON.parse(chartGroupJson).teams[0];
            if (groupData.teamid && groupData.teamid !== 'undefined') {
                const res = this.addContractNetease(groupData);
                if (res) {
                    this.groupChat(groupData);
                }
            }
        },
        // 合同关联云信群组
        addContractNetease(groupData) {
            return this.$axios.put('/interfaceApi/sale/contract_manager/add_contract_netease/' + groupData.contractId + '/' + groupData.teamid);
        },
        // 点群组列表进入群组聊天
        groupChat(data) {
            const callMobileData = {
                conversationId: data.teamid,
                name: data.teamName,
                type: '1',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },
    },
    created() {
        const order_number = this.$route.params.order_number;
        this.getProductorder(order_number);
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
    },
    mounted() {
    },
};
</script>
<style lang="stylus">
.materialPlanInfo
    height calc(100% - 44rpx)
    .hader-nav
        position initial
    .form-con
        height 100%
        overflow-y auto
        overflow-x hidden
        .icondanjubianhao
            font-size 18rpx
            margin-right 10rpx
            float left
            color #666
        .tit-text
            float left
        .van-form
            .van-cell
                padding 0
        .van-collapse-item__content
            padding 0 0 0 0
        .van-cell__title
            font-size 14rpx
        .van-collapse-item__title--expanded
            .van-cell__title
                color #3495FB
                .icondanjubianhao
                    color #3495FB
        .slump
            display inline-block
            width 35rpx
            border none
            &.slump1
                text-align right
                display inline-block
                width 30%
                border none
        .form-group
            .van-cell
                padding 10rpx 10rpx 10px 16rpx;
                font-size 14rpx
            .van-field__control
                text-align right
            .cell-icon
                width 16rpx
                height 16rpx
                display inline-block
                background-repeat no-repeat
                background-size 100% 100%
                margin-top 3rpx
            .cell1
                background-image url(./../../../assets/images/icons/icon_gy_3.png)
            .cell2
                background-image url(./../../../assets/images/icons/icon_gy_7.png)
            .cell3
                background-image url(./../../../assets/images/icons/icon_2.png)
            .cell4
                background-image url(./../../../assets/images/icons/icon_gy_3.png)
            .cell5
                background-image url(./../../../assets/images/icons/icon_gy_2.png)
            .cell6
                background-image url(./../../../assets/images/icons/icon_gy_8.png)
            .cell7
                background-image url(./../../../assets/images/icons/icon_3.png)
            .cell8
                background-image url(./../../../assets/images/icons/icon_33.png)
            .cell9
                background-image url(./../../../assets/images/icons/icon_4.png)
            .cell10
                background-image url(./../../../assets/images/icons/icon_gy_10.png)
            .cell11
                background-image url(./../../../assets/images/icons/icon_30.png)

            .cell12
                background-image url(./../../../assets/images/icons/icon_6.png)
            .cell13
                background-image url(./../../../assets/images/icons/icon_gy_4.png)
            .cell14
                background-image url(./../../../assets/images/icons/icon_11.png)
            .cell15
                background-image url(./../../../assets/images/icons/icon_32.png)
            .cell16
                background-image url(./../../../assets/images/icons/icon_24.png)
            .van-field__left-icon
                margin-right 10rpx
            .van-cell:not(:last-child)::after
                left 0
            .star
                color #E60000
            .van-field__label
                width 160rpx
    .option-con
        width 100%
        padding 0 14rpx 14rpx
        position relative
        p
            font-size 14rpx
            color #626262
            line-height 30rpx
        textarea
            height 132rpx
            width 100%
            border 1px solid #D7D7D7
            border-radius 5rpx
            padding 10rpx
        .iconbeizhu
            position absolute
            left 20rpx
            top 20rpx
            display none
    .btn-con
        display flex
        border-top 2px solid #D60110
        div
            flex 1
            height 39rpx
            text-align center
            line-height 39rpx
            cursor pointer
        .submit-btn
            background #D60110
            color #fff
        .save-btn
            color #D60110

</style>